export function OneSixtyTwoClubIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="24" r="16" />
      <circle cx="24" cy="24" r="10" />
      <text
        x="24"
        y="28"
        textAnchor="middle"
        font-family="'Playfair Display',serif"
        fontSize="14"
        font-weight="700"
        fill="currentColor"
      >
        162
      </text>
    </svg>
  );
}
